import React from 'react'
import classes from "./style.module.scss"
import useStyles from "isomorphic-style-loader/useStyles"
import ListSwiperVideos from './swiper-videos/list-swiper-videos'
import { Iconfont } from '../../../../components/icon/iconfont'



export default props => {
    useStyles(classes)

    const {videos, floatingVideoClickHandle, onClose} = props

    const clickHandle = (index, video) => {
        floatingVideoClickHandle(index, video)
        if(window.GeekoSensors){
            window.GeekoSensors.Track("FloatingVideoClick",{
                video_id: video?.youtubeId,
                video_position: index
            })
        }
    }

    return <div className={classes.FloatingWindow}>
        <div className={classes.Bd}>
            <ListSwiperVideos videos={videos} clickHandle={clickHandle}/>
        </div>
        <span className={classes.Close} onClick={onClose}>
            <Iconfont className={classes.Icon}>&#xe6af;</Iconfont>
        </span>
    </div>
}